import React, { ReactElement } from 'react';

import { Container } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';

import { RedirectContent } from './RedirectContent';

// This component will render when the user is a full power signatory
function Redirect(): ReactElement {
  const { redirectContent } = useContent<RedirectContent>();

  return (
    <Container padding="none">
      {redirectContent &&
        redirectContent.map(({ description }) => (
          <div key="page">{description}</div>
        ))}
    </Container>
  );
}

export default Redirect;
